import styles from './MetricCardIcon.module.css';
import { Icon, IconName } from '../../ui/Icon/Icon';

type MetricCardIconProps = {
  iconName: IconName;
};

export const MetricCardIcon = ({ iconName }: MetricCardIconProps) => {
  return <Icon iconName={iconName} className={styles.metricCardIcon} />;
};
